import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";
import { DumbbellIcon } from "lucide-react";

import { SidebarMenuBadge, SidebarMenuButton, SidebarMenuItem } from "@/shared/ui/sidebar";

import { useDrillsOverview } from "../../api/useDrillsOverview";

const WAITING = msg({
  message: "{pending, plural, one {# task is waiting} other {# tasks are waiting}}",
});

// Пункт «Тренировка» бокового меню: число задач, которые ждут, — значком у пункта
// (в свёрнутом меню — в углу иконки), экранному диктору — словами.
export const DrillsNavItem = () => {
  const { i18n, t } = useLingui();
  const { data } = useDrillsOverview();
  const pending = data?.pending ?? 0;
  const waiting = i18n._({ ...WAITING, values: { pending } });
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild tooltip={pending > 0 ? `${t`Training`}, ${waiting}` : t`Training`}>
        <Link to="/drills">
          <DumbbellIcon aria-hidden="true" />
          <span>
            {t`Training`}
            {pending > 0 && <span className="sr-only">, {waiting}</span>}
          </span>
        </Link>
      </SidebarMenuButton>
      {pending > 0 && <SidebarMenuBadge aria-hidden="true">{pending}</SidebarMenuBadge>}
    </SidebarMenuItem>
  );
};
